/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Ignore href='#' links
        $('a[href="#"]').click(function(e) {
          e.preventDefault();
        });

        // Site header slim/fat behaviour
        $(window).scroll(function() {
          if (typeof detectZoom !== 'undefined') {
            if (isIE8 && detectZoom.zoom() > 1) {
              // cancel fixed header if it's IE8 and zoomed
              return;
            }
          }

          var currentScrollY = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (currentScrollY < 0) { return; } // Ignore scroll beyond scope of the HTML
          
          var scrollUpThreshold = 1;

          var globalNavOffset = 40;

          // When scrolling down over the global header threshold
          var pageJustLoaded = (currentScrollY === lastKnownScrollY);
          if (currentScrollY >= globalNavOffset && lastKnownScrollY < globalNavOffset) {
            $('header.site').addClass('slim');
            
          // When scrolling up over the global header threshold
          } else if (currentScrollY < scrollUpThreshold && lastKnownScrollY > currentScrollY) {
            $('header.site').removeClass('slim');
          }

          lastKnownScrollY = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
        });  

        lastKnownScrollY = 0;
        $(window).trigger('scroll');


        // Login button dropdown 
        $('.show-login').click(function(e) {
          $('.login-form-dropdown').toggleClass('active').parent().toggleClass('dropdown-open');
          if ($('.login-form-dropdown').hasClass('active')) { $('input#uname').focus(); }
        });

        // Close login or search dropdown if click is registered somewhere else
        $('body').mousedown(function(e) {
          if ($('.login-form-dropdown').hasClass('active') && $(e.target).closest('.login-form-dropdown').length === 0 && !$(e.target).hasClass('show-login')) { $('.show-login').click(); }
          if ($('.search-dropdown').hasClass('open') && $(e.target).closest('.search-dropdown').length === 0 && !$(e.target).hasClass('show-search')) { $('.show-search').click(); }
        });

        // Mobile menu button
        $('.open-menu').on('click',function(e) {
          if ($(this).hasClass('close')) {
            $(this).removeClass('close');
            $('.dropdown-menu-wrapper').removeClass('open');
          } else {
            $(this).addClass('close');
            $('.dropdown-menu-wrapper').addClass('open');
          }
        });

        // Search dropdown button 
        $('.show-search').on('click',function(e) {
          $('.search-dropdown').toggleClass('open');
          if ($('.search-dropdown').hasClass('open')) { $('input#search').focus(); }
        });

        // Show/hide filters
        $('.toggle-filter-xs').on('click',function(e) {
          $('.filters-container').slideToggle(200);
          $(this).toggleClass('open');
        });

        // Join form event tracking
        $('#join-form').on('submit',function(e) {
          e.preventDefault();
          ga('send', {'hitType':'event', 'eventCategory':'join', 'eventAction':'click', 'eventLabel':'button', 'eventValue': '30'});
          $('#join-form').off('submit');
          $(this).submit();
        });

        $('.videodlbox a').on('mousedown',function(e) {
          var href = $(this).attr('href');
          href = href.replace('&c=l','');
          href = href.replace('&c=r','');
          href = href.replace('&c=m','');
          if (e.which === 1) {
            // Left button
            href = href+'&c=l';
          } else if (e.which === 2) {
            href = href+'&c=m';
          } else if (e.which === 3) {
            href = href+'&c=r';
          }
          $(this).attr('href',href);
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        // Carousel init
        $('.home-page-carousel').slick({
          dots: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 5000,
          cssEase: 'ease',
          useCSS: true
        });

        setTimeout(function() {
          $('.home-page-carousel').slick('slickNext');
        },2000);
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'single_post': {
      init: function() {

        $('a[data-insert-href]').on('mouseover focus',function() {
          $(this).attr('href',$(this).data('insert-href'));
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
